module.exports = __webpack_public_path__ + "static/media/logo-horizontal.aab78e45.png";